import { useNavigate, useSearch } from "@tanstack/react-router";

/**
 * "Show this page for one person". The record links on a user's detail sheet
 * open an existing page with ?userId=...&userName=...; each page reads it
 * with this hook, applies it to its query, and shows a UserFilterChip so the
 * filter can be cleared. Pages must list userId and userName in validateSearch.
 */
export function useUserFilter() {
  const search = useSearch({ strict: false }) as { userId?: string; userName?: string };
  const navigate = useNavigate();
  const clear = () =>
    navigate({
      to: ".",
      search: ((prev: Record<string, unknown>) => ({ ...prev, userId: undefined, userName: undefined })) as never,
      replace: true,
    });
  return { userId: search.userId, userName: search.userName, clear };
}

/** validateSearch fragment shared by every page that supports the filter. */
export function userFilterSearch(search: Record<string, unknown>): { userId?: string; userName?: string } {
  return {
    userId: typeof search.userId === "string" ? search.userId : undefined,
    userName: typeof search.userName === "string" ? search.userName : undefined,
  };
}
